<div class="container">
  <h2 class="title">{{ editMode ? 'Edit' : 'Add' }} Step</h2>
  
  <div class="divider"></div>
  
  <div class="content">
    <div class="form-group">
      <label class="input-label">Step name</label>
      <input class="form-input" [(ngModel)]="stepName" placeholder="Enter step name" />
    </div>
    
    <div class="form-group">
      <div class="checkbox-container">
        <input type="checkbox" id="enableRotting" [(ngModel)]="enableRotting" />
        <label for="enableRotting" class="checkbox-label">Enable rotting days</label>
      </div>
      
      <div *ngIf="enableRotting" class="rotting-days-container form-group">
        <label class="input-label">Rotting in days</label>
        <input type="number" class="form-input" [(ngModel)]="rotting_in_days" min="0" />
        <div class="hint-text">Number of days before step expires</div>
      </div>
    </div>

    <div class="form-group">
      <label class="input-label">Step Type</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(ngModel)]="step_type" placeholder="Select step type">
          <mat-option *ngFor="let option of availableStepTypeOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="hint-text">Each step type can only be assigned to one step</div>
    </div>
    
    <div class="form-group">
      <label class="input-label">Probability (%)</label>
      <input 
        type="number" 
        class="form-input" 
        [(ngModel)]="probability" 
        min="0" 
        max="100" />
      <div class="hint-text">Enter a value between 0 and 100</div>
      <div *ngIf="isProbabilityInvalid()" class="error-message">
        {{ getProbabilityErrorMessage() }}
      </div>
    </div>
  </div>
  
  <div class="divider"></div>
  
  <div class="actions">
    <button class="btn-cancel" (click)="onCancel()">Cancel</button>
    <button 
      class="btn-create" 
      [disabled]="!stepName || isProbabilityInvalid()" 
      (click)="onSave()">
      {{ editMode ? 'Update' : 'Create' }}
    </button>
  </div>
</div>